import axios from 'axios';

// const baseUrl = process.env.REACT_APP_URL_SERVER;
const baseUrl = process.env.REACT_APP_URL_METIOR;
const apiCode = process.env.REACT_APP_AZURE_CODE;

const Pdf = {

  /**
   * crea un pdf de los resultados generados en el cotizador para el usuario
   */
  createUserPDF: async (data) => {
    const response = axios({
      url: `${baseUrl}/api/calculator?code=${apiCode}`,
      method: 'POST',
      data,
    })
      .then((res) => res.data)
      .catch((err) => {
        const error = err.response?.data.message || err.toString();
        return { error: { message: error.responseJSON?.message } };
      });
    return response;
  },

  /**
   * crea un pdf de los resultados generados en el cotizador
   */
  createClientPDF: async (data) => {
    const response = axios({
      url: `${baseUrl}/api/clientQuotation?code=${apiCode}`,
      method: 'POST',
      data,
    })
      .then((res) => res.data)
      .catch((err) => {
        const error = err.response?.data.message || err.toString();
        return { error: { message: error.responseJSON?.message } };
      });
    return response;
  },

};

export default Pdf;
